
export class MessageData {
    title: string;
    message: string;
    type: string;
    style: string;
    onAction: Function;
    object: object;
}

export class BasicResponse {
    success: boolean;
    errorMessage: string;
}

export class Reference {
    id: string;
    label: string;
}
